document.addEventListener('DOMContentLoaded', function () {
    const subscribeOption = document.querySelector('.purchase_option_subscribe');
    const oneTimeOption = document.querySelector('.purchase_option_one-time');

    function checkActiveOption() {
        const sellingPlansSelects = document.querySelector('input[name="selling_plan_view"]:checked');
        const sellingPlanInput = document.querySelector('.selling_plan_input');

        if (subscribeOption.checked && sellingPlansSelects) {
            sellingPlanInput.value = sellingPlansSelects.value;
        } else if (oneTimeOption.checked) {
            sellingPlanInput.value = '';
        }

    }

    document.querySelector('.delivery-options').addEventListener('change', function (event) {
        subscribeOption.checked = true;
        checkActiveOption();
    });


    checkActiveOption();

    subscribeOption.addEventListener('change', checkActiveOption);
    oneTimeOption.addEventListener('change', checkActiveOption);
});